<template>
  <div class="user">
    <!-- 顶部搜索区域 -->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="部门名称">
          <el-input 
            placeholder="请输入部门名称" 
            v-model="formInline.name"
            style="width: 200px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="部门职能">
          <el-input 
            placeholder="请输入部门职能" 
            v-model="formInline.remark"
            style="width: 200px;"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">
        添加部门
      </el-button>
    </div>

    <!-- 部门列表表格 -->
    <div class="product-content">
      <div class="table-wrap">
        <el-table 
          size="small" 
          :data="tableData" 
          border 
          style="width: 100%" 
          v-loading="loading"
          row-key="ma_depart_id"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        >
          <el-table-column prop="name" label="部门名称" width="200">
            <template slot-scope="scope">
              <div style="display: flex; align-items: center;">
                <span style="margin-left: 10px;">{{ scope.row.name }}</span>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column prop="sort" label="排序" width="100" align="center">
            <template slot-scope="scope">
              <el-input-number 
                width="80"
                v-model="scope.row.sort" 
                size="mini" 
                controls-position="right" 
                :min="0" 
                :max="999"
                @change="handleSortChange(scope.row)"
              ></el-input-number>
            </template>
          </el-table-column>
          
          <el-table-column prop="is_hide" label="状态" width="140" align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.is_hide"
                :active-value="0"
                :inactive-value="1"
                active-text="显示"
                inactive-text="隐藏"
                @change="handleHideChange(scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
          
          <el-table-column prop="create_time" label="创建时间" width="180">
            <template slot-scope="scope">
              {{ scope.row.create_time }}
            </template>
          </el-table-column>
          
          <el-table-column fixed="right" label="操作" width="280" align="center">
            <template slot-scope="scope">
              <el-button 
                @click="editClick(scope.row)" 
                type="text" 
                size="small"
                icon="el-icon-edit"
              >编辑</el-button>
              
              <el-button 
                @click="positionClick(scope.row)" 
                type="text" 
                size="small"
                icon="el-icon-s-grid"
              >岗位管理</el-button>
              
              <el-button 
                @click="deleteClick(scope.row)" 
                type="text" 
                size="small"
                icon="el-icon-delete"
                style="color: #f56c6c;"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <!-- 岗位管理对话框 -->
    <el-dialog
      title="岗位管理"
      :visible.sync="positionDialogVisible"
      width="800px"
      @close="handlePositionDialogClose"
    >
      <PositionManager :department-id="currentDepartmentId" />
    </el-dialog>

     <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
     <Edit :open_add="open_edit" :ma_depart_id="ma_depart_id" v-if="open_edit" @close="closeEdit"></Edit>
  </div>
</template>

<script>
import AfuncApi from '@/api/afunc.js';
import Upload from '@/components/file/Upload.vue';
import PositionManager from './part/PositionManager.vue';
import Add from './part/add.vue';
import Edit from './part/edit.vue';

export default {
  components: {
    Upload,
    Add,
    Edit,
    PositionManager
  },
  data() {
    return {
      loading: true,
      tableData: [],
      pageSize: 20,
      totalDataNumber: 0,
      curPage: 1,

      open_add: false,
      open_edit: false,
      ma_depart_id: 0,
      
      // 搜索表单
      formInline: {
        name: '',
        remark: ''
      },
      
      // 对话框相关
      positionDialogVisible: false,
      currentDepartmentId: '',
      
      // 部门树形数据
      departmentTree: []
    };
  },
  created() {
    this.getTableList();
    this.getDepartmentTree();
  },
  methods: {
    // 获取部门树形数据 - 使用通用API
    async getDepartmentTree() {
      try {
        const response = await AfuncApi.call({
          model: 'ma_depart',
          action: 'index',
          page: 1,
          list_rows: 1000
        });
        
        if (response.code === 1 && response.data.list) {
          this.buildDepartmentTree(response.data.list.data || []);
        }
      } catch (error) {
        console.error('获取部门树失败:', error);
      }
    },
    
    // 构建部门树形结构
    buildDepartmentTree(departments) {
      const tree = [];
      const map = {};
      
      // 创建映射
      departments.forEach(dept => {
        map[dept.ma_depart_id] = { ...dept, children: [] };
      });
      
      // 构建树
      departments.forEach(dept => {
        const node = map[dept.ma_depart_id];
        if (dept.parent_id === 0) {
          tree.push(node);
        } else if (map[dept.parent_id]) {
          map[dept.parent_id].children.push(node);
        }
      });
      
      this.departmentTree = tree;
    },
    
    // 获取表格数据 - 使用通用API
    async getTableList() {
      try {
        this.loading = true;
        
        const response = await AfuncApi.call({
          model: 'ma_depart',
          action: 'index',
          page: this.curPage,
          list_rows: this.pageSize,
          ...this.formInline
        });
        
        if (response.code === 1 && response.data.list) {
          this.tableData = response.data.list.data || [];
          this.totalDataNumber = response.data.list.total || 0;
        }
      } catch (error) {
        console.error('获取部门列表失败:', error);
      } finally {
        this.loading = false;
      }
    },
    
    // 搜索
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },
    
    // 重置搜索
    resetSearch() {
      this.formInline = {
        name: '',
        remark: ''
      };
      this.curPage = 1;
      this.getTableList();
    },
    
    // 分页
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },
    
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },
    
    // 添加部门
    addClick() {

      this.open_add = true;
    },
    
    // 编辑部门
    editClick(row) {
      this.open_edit = true;
      this.ma_depart_id = row.ma_depart_id;
    },
    
    // 岗位管理
    positionClick(row) {
      this.currentDepartmentId = row.ma_depart_id;
      this.positionDialogVisible = true;
    },
    
    // 删除部门 - 使用通用API
    async deleteClick(row) {
      try {
        await this.$confirm('此操作将删除该部门及其所有子部门, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
   
        
        const response = await AfuncApi.call({
          model: 'ma_depart',
          action: 'del',
          ma_depart_id: row.ma_depart_id,
        });
        
        if (response.code === 1) {
          this.$message.success('删除成功');
          this.getTableList();
          this.getDepartmentTree();
        } else {
          this.$message.error(response.msg || '删除失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error);
          this.$message.error('删除失败');
        }
      }
    },
    
    // 处理排序改变 - 使用通用API
    async handleSortChange(row) {
      try {
        const response = await AfuncApi.call({
          model: 'ma_depart',
          action: 'edit',
          ma_depart_id: row.ma_depart_id,
          sort: row.sort
        });
        
        if (response.code === 1) {
          this.$message.success('排序更新成功');
        }
      } catch (error) {
        console.error('更新排序失败:', error);
        this.getTableList(); // 重新加载恢复原排序
      }
    },
    
    // 处理显示/隐藏切换 - 使用通用API
    async handleHideChange(row) {
      try {
        const response = await AfuncApi.call({
          model: 'ma_depart',
          action: 'edit',
          ma_depart_id: row.ma_depart_id,
          is_hide: row.is_hide
        });
        
        if (response.code === 1) {
          this.$message.success('状态更新成功');
        }
      } catch (error) {
        console.error('更新状态失败:', error);
        this.getTableList(); // 重新加载恢复原状态
      }
    },
    
    // 对话框关闭处理
    handlePositionDialogClose() {
      this.currentDepartmentId = '';
    },
    
    /*关闭添加*/
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
  }
};
</script>

<style lang="scss" scoped>
.user {
  padding: 20px;
  background: #fff;
  min-height: calc(100vh - 90px);
}

.common-seach-wrap {
  background: #f8f9fa;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
  
  .demo-form-inline {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
  }
}

.common-level-rail {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
}

.product-content {
  .table-wrap {
    margin-bottom: 20px;
    
    .el-table {
      border: 1px solid #ebeef5;
      border-radius: 4px;
      
      ::v-deep .el-table__header-wrapper {
        background: #f8f9fa;
        
        th {
          background: #f8f9fa;
          font-weight: bold;
          color: #333;
        }
      }
      
      ::v-deep .el-table__row {
        &:hover {
          background-color: #f5f7fa;
        }
      }
    }
  }
  
  .pagination {
    display: flex;
    justify-content: center;
    padding: 20px 0;
  }
}

// 表格操作按钮样式
.el-button--text {
  padding: 4px 8px;
  font-size: 12px;
  
  &.el-button--small {
    padding: 5px 10px;
  }
}

// 响应式调整
@media (max-width: 768px) {
  .common-seach-wrap {
    .demo-form-inline {
      flex-direction: column;
      align-items: stretch;
      
      .el-form-item {
        margin-bottom: 10px;
        width: 100%;
        
        .el-input {
          width: 100%;
        }
      }
    }
  }
  
  .product-content {
    .table-wrap {
      overflow-x: auto;
      
      .el-table {
        min-width: 800px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/plus/ma_depart/index/index.vue